import { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { Collapse as CollapseAntd } from 'antd'
import { Collapse } from '../../../../components/Collapse'
import { Loader } from '../Loader'
import { Empty } from '../Empty'
import { LedByCommunityTable } from './LedByCommunityTable/LedByCommunityTable'
import {
  Typography,
  TYPOGRAPHY_WEIGHT
} from '../../../../components/Typography'
import { useLedByCommunityListContext } from './LedByCommunityContextProvider'
import { getIsLoading } from '../../../../redux/store/common/getters'
import './styles.scss'
import { EditFeesPopup } from './LedByCommunityTable/EditFeesPopup/EditFeesPopup'

const { Panel } = CollapseAntd

export const LedByCommunityList = ({ search }: { search: string }) => {
  const [activeKey, setActiveKey] = useState('')
  const sentinelRef = useRef(null)
  const loading = useSelector(getIsLoading)

  const {
    state: { list },
    actions: { handleLoadMore, setSearch }
  } = useLedByCommunityListContext()

  useEffect(() => {
    setSearch(search)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search])

  useEffect(() => {
    if (!!list.length && !activeKey) {
      setActiveKey(list[0].community.uuid)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [list.length])

  useEffect(() => {
    const sentinelElement = sentinelRef.current
    if (!sentinelElement) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          handleLoadMore()
        }
      },
      {
        root: null,
        rootMargin: '100px',
        threshold: 1.0
      }
    )
    observer.observe(sentinelElement)
    return () => {
      observer.unobserve(sentinelElement)
    }
  }, [handleLoadMore])

  const onChange = (uuid) => setActiveKey(uuid)

  return !loading && !list.length ? (
    <Empty />
  ) : (
    <div>
      <Collapse activeKey={activeKey} onChange={onChange}>
        {list.map((listItem) => (
          <Panel
            key={listItem.community.uuid}
            header={
              <Typography.Headline6 weight={TYPOGRAPHY_WEIGHT.SEMI_BOLD}>
                {listItem.community.name}
              </Typography.Headline6>
            }
          >
            <LedByCommunityTable
              relations={listItem.gpo_relations}
              communityGPOId={listItem.community.gpo_relation?.uuid}
            />
          </Panel>
        ))}
      </Collapse>
      <EditFeesPopup />
      <div ref={sentinelRef} style={{ height: '10px' }} />
      {loading && <Loader itemsLength={list.length} />}
    </div>
  )
}
